import { useWatch } from "react-hook-form"
import config from "@/config"
import { Network, Token } from "@/config/tokens"
import { MultiSelect } from "@/components/ui/multi-select"
import NetworkIcon from "@/components/icons/network"

interface NetworkMultiSelectProps {
  value: Network[];
  onChange: (value: Network[]) => void;
}

export default function NetworkMultiSelect({
  value,
  onChange,
}: NetworkMultiSelectProps) {
  const token: Token = useWatch({ name: "token" })
  const options = Object.values(Network).filter(
    (network) => config.tokenContractAddresses[network][token] !== undefined,
  )

  return (
    <MultiSelect
      selected={value}
      options={options.map((network) => ({
        label: (
          <div className="flex flex-row gap-2 items-center">
            <div className="w-4 h-4">
              <NetworkIcon name={network as Network} />
            </div>
            {network}
          </div>
        ),
        value: network,
      }))}
      onChange={(options) => onChange(options as Network[])}
      className="sm:w-[510px]"
    />
  )
}
